import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { Observable } from 'rxjs';
import { DiagnoseFilter, DiagnoseReportItem, PatientView, PatientViewFilter } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class DiagnosesReportService extends ApiService {
    endPoint = '/api/diagnoses-report';

    getClinicDiagnosesReport(filter: DiagnoseFilter): Observable<DiagnoseReportItem[]> {
        return this.http.post<DiagnoseReportItem[]>(`${this.reportBaseUrl}${this.endPoint}/clinic-diagnoses`, filter);
    }

    getHospitalDiagnosesReport(filter: DiagnoseFilter): Observable<DiagnoseReportItem[]> {
        return this.http.post<DiagnoseReportItem[]>(`${this.reportBaseUrl}${this.endPoint}/hospital-diagnoses`, filter);
    }

    getDiagnoseReportPatients(filter: PatientViewFilter): Observable<PatientView[]> {
        return this.http.post<PatientView[]>(`${this.reportBaseUrl}${this.endPoint}/clinic-patients`, filter);
    }

}
